<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		getCompony
	} from "@/api/moudles/user.js"
	export default {
		name: 'app',
		created() {
			this.getCompony()
		},
		methods: {
			// 获取企业平台后缀
			async getCompony() {
				await getCompony({
					data: {},
					success: res => {
            localStorage.setItem('companyName', res.data.company_name)
            localStorage.setItem('loginBkPath', res.data.login_path)
            localStorage.setItem('logoImg', res.data.logo_img)
						document.title = '项目申报-' + res.data.company_name
					}
				})
			},
		}
	}
</script>

<style>
</style>
